// extracted by mini-css-extract-plugin
module.exports = {"mapWrap":"file-map_mapWrap_cjXcq","screen":"file-map_screen_bL0dl","icon":"file-map_icon_G45SY","boxMap":"file-map_boxMap_DP39B","topPart":"file-map_topPart_Fk0kI"};